import React from 'react';
import styled from 'astroturf/react';

const Chip = styled.span<{ size: 'row' | 'modalcard' }>`
  position: absolute;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  pointer-events: none;
  background: var(--brand-colors-error-900, #920000);
  color: var(--text-white, #ffffff);
  font-family:
    var(--type-font-family-sans-serif, 'DM Sans'), Helvetica, Arial, sans-serif;
  font-weight: var(--type-body-xs-bold-font-weight, 600);
  line-height: 1.2;
  white-space: nowrap;

  &.size-row {
    top: 7px;
    left: -5px;
    height: 12px;
    padding: 0 4.737px;
    border-radius: 2.368px;
    font-size: 7.105px;
  }

  &.size-modalcard {
    top: 10.42px;
    left: -5px;
    height: 17.584px;
    padding: 0 6.941px;
    border-radius: 3.471px;
    font-size: 10.412px;
  }
`;

export type PdfMiniChipProps = {
  size?: 'row' | 'modalcard';
};

export const PdfMiniChip: React.FC<PdfMiniChipProps> = ({ size = 'row' }) => (
  <Chip size={size}>PDF</Chip>
);

export default PdfMiniChip;
